<template>
  <q-layout view="lhh LpR fFf" class="container_body">
    <q-header elevated class="text-grey-8 q-py-xs c_header" height-hint="58">
      <q-toolbar>
        <!-- <span class="dummy"></span> -->
        <q-btn flat dense round @click="leftDrawerOpen = !leftDrawerOpen" aria-label="Menu" icon="menu" />

        <q-separator dark vertical inset />

        <q-toolbar-title style="padding:0px">
          <div class="q-pa-md q-gutter-sm" v-if="home_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="settings_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Shops" icon="widgets" to="/settings" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="shops_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Shops" icon="widgets" to="/shops" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="system_admin_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="System Admin" icon="widgets" to="/SystemAdmin" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="price_watch_addproduct_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Tracker" icon="widgets" :to="{
                path: '/pricewatch/product/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Add Products" icon="widgets" :to="{
                path: '/pricewatch/product/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="price_watch_analytics_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Tracker" icon="widgets" :to="{
                path: '/pricewatch/analytics/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Analytics" icon="widgets" :to="{
                path: '/pricewatch/analytics/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_watch_dashboard_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Tracker" icon="widgets" :to="{
                path: '/pricewatch/dashboard/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Dashboard" icon="widgets" :to="{
                path: '/pricewatch/dashboard/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_watch_results_history_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Tracker" icon="widgets" :to="{
                path:
                  '/pricewatch/resultshistory/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Product Details" icon="widgets" :to="{
                path:
                  '/pricewatch/resultshistory/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_watch_notification_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Tracker" icon="widgets" :to="{
                path: '/pricewatch/notification/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Notifications Settings
                " icon="widgets" :to="{
                  path: '/pricewatch/notification/' + this.$org_encryprt.label,
                }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_select_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_home">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" to="home" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="objectives" icon="widgets" :to="{
                path: '/priceoptimization/home/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_revenue_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Product Selection" icon="widgets" :to="{
                path:
                  '/priceoptimization/revenue/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_resultshistory_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_revenue_recommendation_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Revenue Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/revenue-recommendations/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_profit_recommendation_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Profit Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/profit-recommendations/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_profit">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="objectives" icon="widgets" :to="{
                path: '/priceoptimization/home/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Product Selection" icon="navigation" :to="{
                path:
                  '/priceoptimization/profit?type=profit/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_revenue">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="objectives" icon="widgets" :to="{
                path: '/priceoptimization/home/' + this.$org_encryprt.label,
              }" />

              <q-breadcrumbs-el label="Product Selection" icon="navigation" :to="{
                path:
                  '/priceoptimization/revenue?type=revenue/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_volume">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="objectives" icon="widgets" :to="{
                path: '/priceoptimization/home/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Product Selection" icon="navigation" :to="{
                path:
                  '/priceoptimization/volume?type=volume/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_volume_recommendation_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Volume Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/volume-recommendations/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_revenue_summary_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Revenue Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/revenue-recommendations/' +
                  this.$org_encryprt.label,
              }" />

              <q-breadcrumbs-el label="Revenue Summary" icon="navigation" :to="{
                path:
                  '/priceoptimization/revenue-summary/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_profit_summary_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Results History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Profit Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/profit-recommendations/' +
                  this.$org_encryprt.label,
              }" />

              <q-breadcrumbs-el label="Profit Summary" icon="navigation" :to="{
                path:
                  '/priceoptimization/profit-summary/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_volume_summary_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Result History" icon="widgets" :to="{
                path:
                  '/priceoptimization/resultshistory/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Volume Recommendation" icon="widgets" :to="{
                path:
                  '/priceoptimization/volume-recommendations/' +
                  this.$org_encryprt.label,
              }" />

              <q-breadcrumbs-el label="Volume Summary" icon="navigation" :to="{
                path:
                  '/priceoptimization/volume-summary/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="price_optimization_offline_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Price Optimization" icon="widgets" :to="{
                path: '/priceoptimization/select/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Offline" icon="widgets" :to="{
                path:
                  '/priceoptimization/offline/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="inventory_optimization_select_mode_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Inventory Optimization" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/home/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Select Mode" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/home/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="inventory_optimization_inventory_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Inventory Optimization" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/home/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Inventory" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/inventory/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="inventory_optimization_inventory_result_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Inventory Optimization" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/home/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Inventory Results" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/inventoryresult/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>

          <div class="q-pa-md q-gutter-sm" v-if="inventory_optimization_inventory_store_result_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Inventory Optimization" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/home/' + this.$org_encryprt.label,
              }" />

              <q-breadcrumbs-el label="Inventory Results" icon="widgets" :to="{
                path:
                  '/inventoryoptimization/inventoryresult/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Store Selection" icon="navigation" :to="{
                path:
                  '/inventoryoptimization/inventoryrecommendations' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_repricer_qsmartsell">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="QSmartSell" icon="widgets" :to="{
                path:
                  '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_repricer_dashboard">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="QSmartSell" icon="widgets" :to="{
                path:
                  '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Dashboard" icon="widgets" :to="{
                path: '/amazonrepricer/dashboard' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_repricer_forecast">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="QSmartSell" icon="widgets" :to="{
                path:
                  '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Inventory Forecast" icon="widgets" :to="{
                path: '/amazonrepricer/forecast' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_connect_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="QSmartSell" icon="widgets" :to="{
                path:
                  '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_ad_summary_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adsummary/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Ad Summary" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adsummary/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_ad_schedule_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adschedule/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Ad Schedule" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adschedule/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_keywordSearchTerm_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/keywordSearchTerm/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Keyword and Search Term" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/keywordSearchTerm/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_Campaign_manager">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/campaignmanager/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Campaign Manager" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/campaignmanager/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_ad_performance_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adperfomacereports/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Ad Performance Report" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adperfomacereports/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
          <div class="q-pa-md q-gutter-sm" v-if="amazon_adoptimzation_ad_performance_keyword_path">
            <q-breadcrumbs>
              <q-breadcrumbs-el icon="home" :to="{ path: '/home/' + this.$org_encryprt.label }" />
              <q-breadcrumbs-el label="Amazon Ad Optimization" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/keywordanalysis/' +
                  this.$org_encryprt.label,
              }" />
              <q-breadcrumbs-el label="Keyword Analysis" icon="widgets" :to="{
                path:
                  '/amazonadoptimization/adperfomacereports/keywordanalysis/' +
                  this.$org_encryprt.label,
              }" />
            </q-breadcrumbs>
          </div>
        </q-toolbar-title>
        <div class="input-field" style="margin-left:0px">
          <q-btn-dropdown :label="orgNameDisplay" style="color: black; font-size: 15px">
            <q-list>
              <!-- <router-link :to="{ path: '/r-d' }" style="color: black;font-size:15px;"> -->
              <router-link :to="{ path: '/r-d' }" style="color: black; font-size: 15px">
                <q-item clickable v-for="item in orgName" :key="item" v-close-popup @click="get_orgname(item)">
                  <q-item-section>
                    <q-item-label>{{ maskData(item) }}</q-item-label>
                  </q-item-section>
                </q-item>
              </router-link>
            </q-list>
          </q-btn-dropdown>
        </div>

        <!-- <q-avatar>
              <img src="./assets/headerLogo/baseline_notifications_black_24dp.png">
            </q-avatar> -->

        <!-- <q-btn flat style="background-color: transparent; border: none; outline: none">
          <div class="row items-center no-wrap">
            <router-link to="/customerSupport">
              <q-avatar size="37px">
                <img src="./assets/headset.png" />
              </q-avatar>
            </router-link>
          </div>
        </q-btn>

        <q-btn @click="notifications" flat style="background-color: transparent; border: none; outline: none">
          <notification-bell size="30" :count="counter" counterLocation="upperRight" counterStyle="roundRectangle"
            counterBackgroundColor="#FF0000" counterTextColor="#FFFFFF" iconColor="#000000" />
          <q-dialog v-model="fixed">
            <q-card>
              <q-card-section>
                <div class="text-h6">Notifications</div>
              </q-card-section>

              <q-card-section style="max-height: 50vh; width: 550px" class="scroll">
                <q-separator></q-separator>

                <q-card-section v-for="n in notification_data" :key="n">
                  <div>
                    <div style="display: inline-block">
                      <h4 style="
                          font-size: 15px;
                          float: left;
                          color: red;
                          font-weight: bold;
                        ">
                        {{ gettingDate(n["timestamp_of_creation"]) }}
                      </h4>
                      <span style="padding-left: 1rem; padding-right: 0.5rem"></span>
                      <h4 style="
                          font-size: 15px;
                          float: right;
                          color: blue;
                          font-weight: bold;
                        ">
                        {{ n["notification_heading"] }}
                      </h4>
                    </div>
                  </div>
                  <p :style="n['is_notification_read'] === false
                      ? { 'font-weight': 'bold' }
                      : { 'font-weight': 'italic' }
                    ">
                    {{ n["notification_body"] }}
                  </p>
                  <q-separator></q-separator>
                </q-card-section>
              </q-card-section>

              <q-card-actions align="right">
                <q-btn flat label="Okay" color="primary" v-close-popup></q-btn>
              </q-card-actions>
            </q-card>
          </q-dialog>
        </q-btn> -->

        <q-btn-dropdown flat @click="trackDropdownClick">
          <template v-slot:label>
            <div class="row items-center no-wrap">
              <q-avatar size="40px">
                <img :src="userPhotoUrl" />
              </q-avatar>
            </div>
          </template>

          <!-- <q-item-label header>Profile</q-item-label> -->
          <router-link to="/">
            <q-item clickable v-close-popup @click="sign_out">
              <q-item-section avatar style="color: black">
                <q-avatar icon="exit_to_app" color="red" text-color="white" />
              </q-item-section>
              <q-item-section>
                <q-item-label style="color: black">Sign Out </q-item-label>
                <q-item-label style="font-size: 0.7rem; color: black">{{
                  userFullName
                }}</q-item-label>
              </q-item-section>
            </q-item>
          </router-link>
          <router-link to="/PrivacyPolicy" active-class="drawerItems_active" class="drawerItems" @click="Privacypolicy">
            <q-item clickable v-close-popup>
              <q-item-section>
                <q-item-label style="color: black">Privacy Policy
                </q-item-label>
              </q-item-section>
            </q-item>
          </router-link>

          <router-link :to="{ path: '/subscribe/' + this.$org_encryprt.label }" active-class="drawerItems_active"
            class="drawerItems">
            <q-item clickable v-close-popup @click="subscribe" v-if="authenticate == false">
              <q-item-section>
                <q-item-label style="color: black">Subscribe</q-item-label>
              </q-item-section>
            </q-item>
          </router-link>
          <!-- <router-link :to="{ path: '/unsubscribe/' + this.$org_encryprt.label }" active-class="drawerItems_active"
            class="drawerItems">
            <q-item clickable v-close-popup v-if="authenticate == true">
              <q-item-section>
                <q-item-label style="color: black" disabled> Unsubscribe</q-item-label>
              </q-item-section>
            </q-item>
          </router-link> -->
        </q-btn-dropdown>
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered :width="240" content-class="leftDrawer">
      <q-list>
        <q-item-label header class="leftDrawerHeading">UNIQIN AI</q-item-label>
        <div class="user items-center no-wrap justify-center w-100 q-mt-xl">
          <q-avatar size="700%" style="border-radius: 14px; overflow: hidden">
            <img :src="logosource" @error="handleImageError" />
          </q-avatar>
          <q-item-label style="font-size: 0.9rem; color: black" class="q-mt-md text-h6">{{ selectedorgname
          }}</q-item-label>
        </div>

        <div class="home-shop">
          <router-link :to="{ path: '/homedashboard/' + this.$org_encryprt.label }" active-class="Items_active"
            class="drawerItems">
            <q-item clickable @click="checkPath" class="q-item-class">
              <div class="home" style="display: flex;">
                <q-item-section avatar> <q-icon name="house" /></q-item-section>
                <q-item-section>
                  Home Dashboard

                </q-item-section>
              </div>
            </q-item>
          </router-link>
        </div>
        <div>

          <router-link :to="{ path: '/communication/' + this.$org_encryprt.label }" class="drawerItems"
            active-class="Items_active">
            <q-item clickable @click="communication_path" class="q-item-class">
              <div class="home" style="display: flex;">
                <q-item-section avatar> <q-icon name="call" /></q-item-section>
                <q-item-section>
                  Communication

                </q-item-section>
              </div>
            </q-item>
          </router-link>

        </div>
        <!-- <div>

          <router-link :to="{ path: '/settings' }" class="drawerItems" active-class="Items_active">
            <q-item clickable @click="settings_path" class="q-item-class">
              <div class="home" style="display: flex;">
                <q-item-section avatar> <q-icon name="settings" /></q-item-section>
                <q-item-section>
                  Settings

                </q-item-section>
              </div>
            </q-item>
          </router-link>

        </div> -->
        <!-- <div class="home-shop  justify-around q-px-sm q-mb-md ">
          <router-link to="/SystemAdmin" active-class="drawerItems_active" class="drawerItems">
            <q-item clickable>
              <div class="shop">
                <q-item-section avatar> <q-icon name="shop" /> </q-item-section>
                <q-item-section> System Admin </q-item-section>
              </div>
            </q-item>
          </router-link>
        </div> -->
      </q-list>
      <!-- <div class="q-mx-md q-py-md left-dashboard"> -->
      <!-- <q-item clickable class="q-item-class">
        <q-item-section avatar class="left-icons">
          <font-awesome-icon icon="fa-solid fa-tools" class="icons" />
        </q-item-section>
        <q-item-section class="sidebartext" @click="togglePanelItems"><span><strong>Amazon Tools</strong> <span
              v-bind:class="isExpanded ? 'arrow down-1' : 'arrow up-1'"></span></span>
        </q-item-section>
      </q-item> -->
      <!-- <div v-show="isExpanded" style="margin-left: 10px;">
          
                  <q-item clickable class="q-item-class">
                    <q-item-section avatar class="left-icons">
                      <font-awesome-icon icon="fa-solid fa-search-dollar" class="icons" />
                    </q-item-section>
                    <q-item-section class="sidebartext" style="color:#282828; font-weight: 600;" @click="salesoptimization = !salesoptimization"> Sales Optimization </q-item-section>
                  </q-item>
                  <div style="margin-left: 10px;">
                          <router-link :to="{ path: '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label }" active-class="Items_active"
                        class="Items">
                        <q-item clickable class="q-item-class" v-if="salesoptimization== true">
                          <q-item-section avatar class="left-icons">
                            <font-awesome-icon icon="fa-solid fa-bar-chart" class="icons" />
                          </q-item-section>
                          <q-item-section> Repricer </q-item-section>
                        </q-item>
                      </router-link>
          </div>
          
          </div> -->
      <div>
        <!-- <q-item
            :class="{ highlighted: adoptimization }"
            clickable
            class="q-item-class"
          >
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-ad" class="icons" />
            </q-item-section>
            <q-item-section
              class="sidebartext"
              style="color: unset; font-weight: 600"
              @click="togglePanelItems"
              ><span
                ><strong>Ad Optimization</strong>
                <span
                  v-bind:class="isExpanded ? 'arrow up-1' : 'arrow down-1'"
                ></span
              ></span>
            </q-item-section>
          </q-item> -->
        <div v-show="isExpanded" style="margin-left: 20px">
          <router-link :to="{
            path:
              '/amazonadoptimization/campaignmanager/' +
              this.$org_encryprt.label,
          }" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Campaign Manager')"> Campaign Manager
              </q-item-section>

            </q-item>
          </router-link>
          <router-link :to="{
            path:
              '/amazonadoptimization/adschedule/' +
              this.$org_encryprt.label,
          }" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Advertisement Schedular')">
                Advertisement Scheduler </q-item-section>

            </q-item>
          </router-link>
          <router-link :to="{
            path:
              '/amazonadoptimization/keywordSearchTerm/' +
              this.$org_encryprt.label,
          }" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Keyword and search Term')"> Keyword and
                Search Term </q-item-section>
            </q-item>
          </router-link>
        </div>
        <!-- <q-item
            :class="{ highlighted: adPerformaceDashboard }"
            clickable
            class="q-item-class"
          >
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-chart-line" class="icons" />
            </q-item-section>
            <q-item-section
              class="sidebartext"
              style="color: unset; font-weight: 600"
              @click="togglereports"
              ><span
                ><strong>Ad Performance Reports</strong>
                <span
                  v-bind:class="
                    performancereport ? 'arrow up-1' : 'arrow down-1'
                  "
                ></span></span
            ></q-item-section>
          </q-item> -->
        <div v-show="performancereport" style="margin-left: 20px">
          <router-link :to="{
            path:
              '/amazonadoptimization/adperfomacereports/' +
              this.$org_encryprt.label,
          }" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-bar-chart" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext-semi" @click="trackingadoptimization('Campaign Report')">Campaign
                Report</q-item-section>

            </q-item>
          </router-link>
          <router-link :to="{
            path:
              '/amazonadoptimization/adperfomacereports/keywordanalysis/' +
              this.$org_encryprt.label,
          }" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-pie-chart" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext-semi" @click="trackingadoptimization('Keyword Analysis')">Keyword
                Analysis</q-item-section>

            </q-item>
          </router-link>
        </div>
      </div>
      <div>
        <div>
          <!-- <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Campaign Manager')"> Campaign Manager
              </q-item-section>
            </q-item> -->
          <div v-show="subMenuOpen" style="margin-left: 10px">
            <!-- <q-item :class="{ 'highlighted': salesoptimization }" clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-search-dollar" class="icons" />
            </q-item-section>
            <q-item-section class="sidebartext" style="color:unset; font-weight: 600; " @click="salesoptimization = !salesoptimization"> Sales Optimization </q-item-section>
          </q-item> -->
            <div style="margin-left: 10px">
              <router-link :to="{
                path:
                  '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label,
              }" active-class="Items_active" class="Items">
                <q-item clickable class="q-item-class">
                  <q-item-section avatar class="left-icons">
                    <font-awesome-icon icon="fa-solid fa-bar-chart" class="icons" />
                  </q-item-section>
                  <q-item-section class="sidebartext">
                    Repricer
                  </q-item-section>
                </q-item>
              </router-link>
            </div>
          </div>

          <div style="margin-left: 20px">
            <router-link :to="{
              path: '/pricewatch/dashboard/' + this.$org_encryprt.label,
            }" active-class="Items_active" v-show="subMenuOpen" class="Items">
              <q-item clickable class="q-item-class">
                <q-item-section avatar class="left-icons">
                  <font-awesome-icon icon="fa-solid fa-line-chart" class="icons" />
                </q-item-section>
                <q-item-section class="sidebartext">
                  Dashboard
                </q-item-section>
              </q-item>
            </router-link>
            <router-link :to="{
              path: '/pricewatch/product/' + this.$org_encryprt.label,
            }" active-class="Items_active" v-show="subMenuOpen" class="Items">
              <q-item clickable class="q-item-class">
                <q-item-section avatar class="left-icons">
                  <font-awesome-icon icon="fa-solid fa-shopping-cart" class="icons" />
                </q-item-section>
                <q-item-section class="sidebartext">
                  Add Products</q-item-section>
              </q-item>
            </router-link>
            <router-link :to="{
              path:
                '/pricewatch/resultshistory/' + this.$org_encryprt.label,
            }" active-class="Items_active" v-show="subMenuOpen" class="Items">
              <q-item clickable class="q-item-class">
                <q-item-section avatar class="left-icons">
                  <font-awesome-icon icon="fa-solid fa-box-open" class="icons" />
                </q-item-section>
                <q-item-section class="sidebartext">
                  Product Details
                </q-item-section>
              </q-item>
            </router-link>
            <router-link :to="{
              path: '/pricewatch/analytics/' + this.$org_encryprt.label,
            }" active-class="Items_active" v-show="subMenuOpen" class="Items">
              <q-item clickable class="q-item-class">
                <q-item-section avatar class="left-icons">
                  <font-awesome-icon icon="fa-solid fa-search" class="icons" />
                </q-item-section>
                <q-item-section class="sidebartext">
                  Analytics
                </q-item-section>
              </q-item>
            </router-link>
            <router-link :to="{
              path: '/pricewatch/notification/' + this.$org_encryprt.label,
            }" active-class="Items_active" v-show="subMenuOpen" class="Items">
              <q-item clickable class="q-item-class">
                <q-item-section avatar class="left-icons">
                  <font-awesome-icon icon="fa-solid fa-comments" class="icons" />
                </q-item-section>
                <q-item-section class="sidebartext">
                  Notifications Settings</q-item-section>
              </q-item>
            </router-link>
          </div>
        </div>
      </div>
      <div>
        <router-link :to="{ path: '/settings' }" class="drawerItems">
          <q-item clickable @click="settings_path" class="q-item-class">
            <div class="home" style="display: flex;">
              <q-item-section avatar> <q-icon name="settings" /></q-item-section>
              <q-item-section class="sidebartext" @click="settingsItems"><span><strong>Settings</strong> <span
                    v-bind:class="isUser ? 'arrow down-1' : 'arrow up-1'"></span></span>
              </q-item-section>
            </div>
          </q-item>
        </router-link>

      </div>
      <div v-if="isUser">

        <router-link :to="{ path: '/inviteuser/' + this.$org_encryprt.label }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <q-icon name="group_add" />
            </q-item-section>
            <q-item-section class="sidebartext"> User Settings </q-item-section>
          </q-item>
        </router-link>

      </div>


      <div class="q-mx-md q-py-md left-dashboard" v-if="price_optimization_path">
        <router-link :to="{
          path: '/priceoptimization/select/' + this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-line-chart" class="icons" />
            </q-item-section>
            <q-item-section @click="priceoptimization('Select Mode')"> Select Mode </q-item-section>
          </q-item>
        </router-link>
        <router-link :to="{
          path: '/priceoptimization/revenue/' + this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-shopping-cart" class="icons" />
            </q-item-section>
            <q-item-section @click="priceoptimization('Product Selection')"> Product Selection</q-item-section>
          </q-item>
        </router-link>
        <router-link :to="{
          path:
            '/priceoptimization/resultshistory/' + this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-box-open" class="icons" />
            </q-item-section>
            <q-item-section @click="priceoptimization('Results History')"> Results History </q-item-section>
          </q-item>
        </router-link>
      </div>

      <div class="q-mx-md q-py-md left-dashboard" v-if="amazon_application_path">
        <!-- <div>
        <router-link :to="{ path: '/amazonrepricer/dashboard/' + this.$org_encryprt.label }" active-class="Items_active"
          class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-line-chart" class="icons" />
            </q-item-section>
            <q-item-section> Dashboard </q-item-section>
          </q-item>
        </router-link>
      </div> -->
        <!-- <div>
        <router-link :to="{ path: '/amazonrepricer/qsmartsell/' + this.$org_encryprt.label }" active-class="Items_active"
          class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-bar-chart" class="icons" />
            </q-item-section>
            <q-item-section @click="repricer"> Repricer </q-item-section>
          </q-item>
        </router-link>
      </div> -->
        <!-- <div>
        <router-link :to="{ path: '/amazonrepricer/forecast/' + this.$org_encryprt.label }" active-class="Items_active"
          class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-line-chart" class="icons" />
            </q-item-section>
            <q-item-section> Inventory Forecast </q-item-section>
          </q-item>
        </router-link>
      </div> -->
      </div>
      <div class="q-mx-md q-py-md left-dashboard">
        <div>
          <!-- <router-link :to="{ path: '/amazonadoptimization/adsummary/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-list" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext"> Ad Summary </q-item-section>
            </q-item>
          </router-link> -->
          <!-- <router-link :to="{ path: '/amazonadoptimization/campaignmanager/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Campaign Manager')"> Campaign Manager </q-item-section>
            </q-item>
          </router-link> -->
          <!-- <router-link :to="{ path: '/amazonadoptimization/adschedule/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Advertisement Schedular')"> Advertisement Scheduler </q-item-section>
            </q-item>
          </router-link> -->
          <!-- <router-link :to="{ path: '/amazonadoptimization/keywordSearchTerm/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-rectangle-ad" />
              </q-item-section>
              <q-item-section class="sidebartext" @click="trackingadoptimization('Keyword and search Term')">  Keyword and Search Term </q-item-section>
            </q-item>
          </router-link> -->
          <!-- <router-link to="/amazonadoptimization/automationrules" active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-clipboard-check" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext"> Automation Rules </q-item-section>
            </q-item>
          </router-link> -->

          <!-- <router-link :to="{ path: '/amazonadoptimization/adperfomacereports/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class" v-if="adPerformaceDashboard == true">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-bar-chart" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext-semi" @click="trackingadoptimization('Campaign Report')">Campaign Report2</q-item-section>
            </q-item>
          </router-link> -->
          <!-- <router-link
            :to="{ path: '/amazonadoptimization/adperfomacereports/keywordanalysis/' + this.$org_encryprt.label }"
            active-class="Items_active" class="Items">
            <q-item clickable class="q-item-class" v-if="adPerformaceDashboard == true">
              <q-item-section avatar class="left-icons">
                <font-awesome-icon icon="fa-solid fa-pie-chart" class="icons" />
              </q-item-section>
              <q-item-section class="sidebartext-semi" @click="trackingadoptimization('Keyword Analysis')">Keyword Analysis</q-item-section>
            </q-item>
          </router-link> -->

        </div>
      </div>

      <div class="q-mx-md q-py-md left-dashboard" v-if="inventory_optimization_path">
        <router-link :to="{
          path: '/inventoryoptimization/home/' + this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-line-chart" class="icons" />
            </q-item-section>
            <q-item-section> Select Mode </q-item-section>
          </q-item>
        </router-link>
        <router-link :to="{
          path:
            '/inventoryoptimization/inventory/' + this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-shopping-cart" class="icons" />
            </q-item-section>
            <q-item-section>Inventory </q-item-section>
          </q-item>
        </router-link>
        <router-link :to="{
          path:
            '/inventoryoptimization/inventoryresult/' +
            this.$org_encryprt.label,
        }" active-class="Items_active" class="Items">
          <q-item clickable class="q-item-class">
            <q-item-section avatar class="left-icons">
              <font-awesome-icon icon="fa-solid fa-box-open" class="icons" />
            </q-item-section>
            <q-item-section> Inventory Results </q-item-section>
          </q-item>
        </router-link>
      </div>

      <!-- <div class="left-dashboard-1 q-mx-md q-pb-sm">
        <router-link to="/" active-class="drawerItems_active" class="drawerItems">
        <q-item clickable v-close-popup>
            <q-item-section avatar>
              <q-avatar icon="exit_to_app" color="#edf1f5" text-color="#bec7d6" />
            </q-item-section>
            <q-item-section>
              <q-item-label style="color: black" @click="sign_out">Sign Out </q-item-label>
            </q-item-section>
          </q-item>
        </router-link>
      </div> -->

      <!-- <div class="subscription-panel q-mx-md">
        <p class="title-sub q-mt-lg q-mb-lg">Subscription Details</p>
        <div class="sub-data row q-mt-sm">
          <div class="col">Expire Date</div>
          <div class="col">
            {{ subscriptionEndDate }}
          </div>
        </div>
        <div class="sub-data row q-mt-sm">
          <div class="col">Current Plan</div>
          <div class="col">
            {{ subscriptionPlan }}
          </div>
        </div>
        <div class="row q-mt-sm" style="text-align: end">
          <div class="col-7">
            <router-link v-if="isSubscriptionExpired" :to="{ path: '/subscribe/' + this.$org_encryprt.label }"
              class="purchase">
              Purchase Now
            </router-link>
          </div>
          <div class="col">
            <div class="row">
              <div class="q-mr-sm col" @click="trackingcancel">
                <router-link :to="{ path: '/unsubscribe/' + this.$org_encryprt.label }" class="cancel" >
                Cancel
              </router-link>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <router-link to="/" class="drawerItems sign_out">
        <q-item clickable v-close-popup>
          <q-item-section avatar>
            <q-avatar icon="exit_to_app" color="#edf1f5" text-color="#bec7d6" />
          </q-item-section>
          <q-item-section>
            <q-item-label style="color: black" @click="sign_out">Sign Out </q-item-label>

          </q-item-section>
        </q-item>
      </router-link> -->
      <div>
        <q-blur v-if="showorganizationform" :intensity="5" class="blur-background">
          <q-dialog v-model="showorganizationform">
            <q-card class="organizationform">
              <q-card-section>
                <q-form @submit.prevent="proceed">
                  <div class="input-organization">
                    <div>
                      <div styel="display: flex; justify-content:center;" class="q-mb-md">
                        <h6>Let's go! You're almost there...</h6>
                      </div>
                      <div class="q-mb-md">
                        <q-input outlined v-model="org_name" placeholder="Enter Your Organization Name" :dense="dense"
                          bg-color="white" />
                      </div>
                      <div class="q-mb-md">
                        <q-select v-model="Typeofbusiness" label="Select Your Type Of Business" :options="businessTypes"
                          outlined />
                      </div>
                      <div class="q-mb-md">
                        <q-input outlined v-model="targeted_monthly_sale" label="Monthly AD Sales" type="text" />
                      </div>
                      <div class="q-mb-md">
                        <q-input outlined v-model="targeted_ad_cost" label="Monthly AD Cost" type="text" />
                      </div>

                      <div class="q-mb-md">
                        <q-select v-model="operating_country" label="Operating Country" :options="Countries" outlined />
                      </div>
                      <div class="q-mb-lg">
                        <q-select v-model="preferred_timezone" label="Preferred Time Zone" :options="timezone" outlined />
                      </div>

                      <div class="q-mb-md">
                        <center>
                          <q-btn label="Proceed" type="submit" style="
                              background-image: linear-gradient(
                                92deg,
                                #f0772c,
                                #f95776 126%
                              );
                              color: white;
                            " />
                        </center>
                      </div>
                    </div>
                  </div>
                </q-form>
                <!-- <q-card-media style="margin-left: 5%; ">
          <img src="../assets/login_img.webp" alt=""  style="width: 90%; height: 90%; object-fit:contain; margin-right: 0; padding-right: 0;" >
        </q-card-media> -->
              </q-card-section>
            </q-card>
          </q-dialog>
        </q-blur>
      </div>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>
<script>
import { Auth } from "aws-amplify";
import awsconfig from "./aws-exports";
import Analytics from "@aws-amplify/analytics";
import NotificationBell from "vue-notification-bell";
import mixpanel from "mixpanel-browser";
import { mounted1 } from "./components/pricewatch/Product.vue";

export default {
  // name: 'LayoutDefault',
  components: {
    //  EssentialLink,
    //  TraversalButtons
    NotificationBell,
  },
  data() {
    return {
      // layoutInitialized : false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      showItems: false,
      organizationId: "",
      fixed: false,
      showTab: false,
      showHist: false,
      showTabI: false,
      showTab2: false,
      showHist2: false,
      showMaskedData: false,
      counter: 0,
      counting: 0,
      notification_data: [],
      leftDrawerOpen: false,
      authenticate: false,
      orgName: [],
      orgNameDisplay: "",
      selectedorgname: "",
      selectedorg: "",
      defaultLogoSource: "https://seller-logos.s3.us-west-2.amazonaws.com/test_logos/blank-profile-picture.webp",
      logosource: "",
      oganisationData: [],
      adPerformaceDashboard: false,
      salesoptimization: false,
      adoptimization: false,
      panelHeading: "Panel Heading",
      panelItems: ["Item 1", "Item 2", "Item 3"],
      isExpanded: false,
      isUser: false,
      performancereport: false,
      subMenuOpen: false,
      recomI: window.location.pathname == "/InventoryResults",
      recom:
        window.location.pathname ==
        "/priceoptimization/revenue/recommendations",
      proselectP: window.location.pathname == "/priceoptimization/revenue",
      profileDropDown: false,
      // userPhotoUrl: "",
      // userFullName: "",
      // essentialLinks: linksData,
      end_points: [],
      subscriptionPlan: "",
      subscriptionEndDate: "",
      showorganizationform: false,
      org_name: "",
      Typeofbusiness: "",
      targeted_monthly_sale: null,
      targeted_ad_cost: null,
      tax_details: "",
      operating_country: "",
      preferred_timezone: "",
      businessTypes: [
        { label: "Seller", value: "seller" },
        { label: "Agency", value: "agency" },
        { label: "Brand", value: "brand" },
      ],
      Countries: [
        { label: "India", value: "india" },
        { label: "US", value: "us" },
        { label: "UK", value: "uk" },
        { label: "Germany", value: "germany" },
      ],
      timezone: [
        { value: "Asia/Kolkata", label: "Indian Standard Time (IST)" },
        { value: "UTC", label: "Coordinated Universal Time (UTC)" },
        { value: "America/New_York", label: "Eastern Time (US & Canada)" },
        { value: "Europe/London", label: "Greenwich Mean Time (GMT)" },
        { value: "Europe/Berlin", label: "Central European Time (CET)" },
      ],
      isClicked: false,
      isCommunicationClicked: false,
    };
  },


  // mounted(){
  //   const email = localStorage.getItem('email')
  //   var productsURL = this.api_url + "/multiuser/get_org_form_details";
  //   this.$http.get(productsURL).then((response) => {
  //     console.log('responsedata',response.data)
  //     if (response.data.length=== false){
  //       this.showorganizationform=true

  //   }
  //   else{
  //     this.showorganizationform=false;
  //   }
  //   })

  // },
  created() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });

    //browser stored data assigning to variable
    // await this.waitForInitialized();
    // hiding in 3s
    //console.log("window.location.pathname", window.location.pathname);

    // var productsURL = await this.api_url + "/multiuser/get_accessable_org_list_v3";
    // try {
    //         const response = this.$http.post(productsURL);

    var productsURL = this.api_url + "/multiuser/get_accessable_org_list_v3";
    this.$http
      .get(productsURL)
      .then((response) => {
        console.log("response.data", response.data);
        if (response.data != 0) {

          localStorage.setItem("top_level_orgid", response.data[0]['top_level_orgid']);
          localStorage.setItem("top_level_org_name", response.data[0]['top_level_org_name']);
          localStorage.setItem("ac_conn_status", response.data[0]['ac_conn_status']);
          this.$top_level_orgid.label = localStorage.getItem("top_level_orgid");
          this.$userVerified.label = response.data[0]['verification_status'];
          console.log('from if', localStorage.getItem("top_level_orgid"), 'status:', this.$userVerified.label);

          const allOrgData = response.data[0]["org_details"];
          console.log('allOrgData:', allOrgData);
          this.$allorgList.list = allOrgData;
          console.log('allOrgData data,', this.$allorgList.list.length);
          if (allOrgData && allOrgData.length > 0) {
            this.oganisationData = this.filteredItems(allOrgData);
            console.log('fileterd data,', this.oganisationData.length);
            if (this.oganisationData.length > 0) {
              this.$orgName.label = this.oganisationData[0]["profile_name"];

              console.log('connected org data', this.oganisationData)
              // The list is not empty
              this.$org_id.label = this.oganisationData[0]["org_id"];
              // this.orgNameDisplay = response.data[0]['org_name'];
              const email = this.$store.state.credentials["attributes"]["email"];
              if (email === "support@uniqin.ai") {
                this.orgNameDisplay = "Demo";
              } else {
                this.orgNameDisplay = this.oganisationData[0]["profile_name"];
              }
              this.$orgName.label = this.oganisationData[0]["profile_name"];
              //storing organization id in browser
              this.globalVariable = this.oganisationData[0]["org_id"];
              localStorage.setItem("key", this.globalVariable);
              localStorage.setItem("org_name", this.orgNameDisplay);
              console.log('org name::', this.orgNameDisplay)
              //Assigning Encryption value for url
              this.$org_encryprt.label = this.oganisationData[0]["encoded_org_id"];
              this.$cookies
                .keys()
                .forEach((cookie) => this.$cookies.remove(cookie));
              let result = this.oganisationData;
              this.data_temp = this.oganisationData;
              let data1 = result.map((item) => item.profile_name).sort((a, b) => b.localeCompare(a));

              this.orgName = data1;
              // this.$q.loading.hide();
              this.subscriptionPlan = this.oganisationData["subscription_type"];
              this.subscriptionEndDate = this.oganisationData[0][
                "subscription_end_date"
              ].slice(0, 10);
              console.log('final org:', this.$org_id.label, localStorage.getItem("key"))
              this.$cookies
                .keys()
                .forEach((cookie) => this.$cookies.remove(cookie));
              // let end_point = this.$CryptoJS.AES.encrypt(
              //   'authenticated',
              //   process.env.VUE_APP_ENCRYPTION_SECRET_KEY
              // ).toString();
              // this.$cookies.set("login_authentication", end_point, 0);
              // this.authenticate = true;

              // this.$store.dispatch("setSignedIn", true);
              // this.$layoutInitialized.label = true
              // this.$router.push({
              //   name: "SignIn",
              // });
              // this.$q.loading.hide();
            }

          } else {
            console.log('else')
            console.log('top level org', this.$top_level_orgid)
            // this.$q.loading.hide();
            // let end_point = this.$CryptoJS.AES.encrypt(
            //   "authenticated",
            //   process.env.VUE_APP_ENCRYPTION_SECRET_KEY
            // ).toString();
            // this.$cookies.set("login_authentication", end_point, 0);
            // this.authenticate = true;
            // this.$layoutInitialized.label = true
            // this.$store.dispatch("setSignedIn", true);

            // this.$router.push({
            //   name: "SignIn",
            // });
            // this.$q.loading.hide();
          }


        } else {

          // this.$q.loading.hide();
          this.$cookies
            .keys()
            .forEach((cookie) => this.$cookies.remove(cookie));
          localStorage.setItem("ac_conn_status", false);
          // let end_point = this.$CryptoJS.AES.encrypt(
          //   'authenticated',
          //   process.env.VUE_APP_ENCRYPTION_SECRET_KEY
          // ).toString();
          // this.$cookies.set("login_authentication", end_point, 0);
          // this.authenticate = true;
          // this.$layoutInitialized.label = true


          // this.$store.dispatch("setSignedIn", true);
          // // this.$q.loading.hide();
          // this.$router.push({
          //   name: "SignIn",
          // });
          // console.log('after push')
          // this.$q.loading.hide();
          // this.get_notifications();
        }
      }).catch(() => {
        this.$q.loading.hide();
      }).finally(() => {
        console.log('else')
        console.log('allOrgData data final,', this.$allorgList.length)
        // this.$q.loading.hide();
        let end_point = this.$CryptoJS.AES.encrypt(
          "authenticated",
          process.env.VUE_APP_ENCRYPTION_SECRET_KEY
        ).toString();
        this.$cookies.set("login_authentication", end_point, 0);
        this.authenticate = true;
        this.$layoutInitialized.label = true
        this.$store.dispatch("setSignedIn", true);

        this.$router.push({
          name: "SignIn",
        });
        this.$q.loading.hide();
      });

    this.updatePinpointEndpoint();
    this.pageTrack();




    // var productsURL = this.api_url + "/products/get_subscription_details";

    //   this.$http.post(productsURL).then((response) => {

    //     if(response.data[0] == "Y" && response.data[1]== "advertisement")
    //     {
    //       let end_point = this.$CryptoJS.AES.encrypt(
    //            'authenticated',
    //            process.env.VUE_APP_ENCRYPTION_SECRET_KEY
    //          ).toString();
    //          this.$cookies.set("login_authentication", end_point, 0);
    //         this.authenticate = true;
    //          this.$store.dispatch("setSignedIn", true);

    //     }
    //     else if(response.data[0] == 'Y' )
    //     {
    //       let end_point = this.$CryptoJS.AES.encrypt(
    //            'authenticated',
    //            process.env.VUE_APP_ENCRYPTION_SECRET_KEY
    //          ).toString();

    //          this.$cookies.set("login_authentication1", end_point, 0);
    //          this.authenticate = true;
    //          this.$store.dispatch("setSignedIn", true);

    //     }
    //     else
    //     {
    //       this.$q.loading.hide();
    //       // this.$store.dispatch("setSignedIn", false);
    //       this.authenticate = false;

    //       this.$router.push({
    //       name: "CommonNotAuthenticated",
    //     });
    //     }

    //     this.$q.loading.hide();
    //     this.get_notifications();

    //   });

    // var resultshistoryURL =
    //   this.api_url + "/products/authenticating/" + "login/" + "authentication";

    // this.$http.get(resultshistoryURL).then((response) => {
    //   let result = response.data;

    //   if (result[0] === "N") {
    //     this.$q.loading.hide();
    //     //this.$store.dispatch("setSignedIn", false);

    //     this.$router.push({
    //       name: "CommonNotAuthenticated",
    //     });
    //   } else if (result[0] === "Y") {
    //
    //       "process.env.VUE_APP_ENV",
    //       process.env.VUE_APP_ENCRYPTION_SECRET_KEY
    //     );
    //     for (let i = 0; i < result[1].length; i++) {
    //       if (result[1][i]["end_point_list"] == "login/authentication") {
    //         let end_point = this.$CryptoJS.AES.encrypt(
    //           result[1][i]["end_point_list"],
    //           process.env.VUE_APP_ENCRYPTION_SECRET_KEY
    //         ).toString();
    //         this.$cookies.set("login_authentication", end_point, 0);
    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/home")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_home",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/product")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_product",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/analytics")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_analytics",end_point,0);

    //       }

    //       else if(result[1][i]['end_point_list'] == "pricewatch/resultshistory")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_resultshistory",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/notification")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_notification",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/dashboard")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_dashboard",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "pricewatch/dashboard2")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("pricewatch_dashboard2",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "priceoptimisation/product")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("priceoptimisation_product",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "priceoptimisation/analytics")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("priceoptimisation_analytics",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "priceoptimisation/resultshistory")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("priceoptimisation_resultshistory",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "priceoptimisation/notification")
    //       {
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("priceoptimisation_notification",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "priceoptimisation/home")
    //       {
    //          //console.log("amazon: ",result[1][i]['end_point_list'] );
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("priceoptimisation_home",end_point,0);

    //       }
    //       else if(result[1][i]['end_point_list'] == "amazonauthentication")
    //       {
    //         //console.log("amazon: ",result[1][i]['end_point_list'] );
    //         let end_point = this.$CryptoJS.AES.encrypt(result[1][i]['end_point_list'], process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString()
    //         this.$cookies.set("amazon_authentication",end_point,0);

    //       }

    //     }
    //     this.$store.dispatch("setSignedIn", true);
    //     mixpanel.time_event("Log Out");
    //     this.$q.loading.hide();

    //     //console.log("all cookies", this.$cookies.keys());
    //   }

    //   this.$q.loading.hide();
    //   this.get_notifications();
    // });
  },

  methods: {
    trackDropdownClick() {
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('LogOut Dropdown', {
        Path: 'User accessed Logout dropdown',
        UserEmail: localStorage.getItem('email'),
        Date: new Date().toDateString(),
        Time: istTime,

      });
    },
    Privacypolicy() {
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('Privacy Policy', {
        Path: 'User accessed Privacy policy',
        UserEmail: localStorage.getItem('email'),
        Date: new Date().toDateString(),
        Time: istTime,

      });

    },
    async waitForInitialized() {
      console.log(this.$store.state.initializationComplete)
      return new Promise((resolve) => {
        const initialCheck = () => {
          if (this.$store.state.initializationComplete) {
            resolve();
          } else {
            setTimeout(initialCheck, 100); // Adjust the interval as needed
          }
        };
        initialCheck();
      });
    },
    proceed() {
      const formData = {
        top_level_org_name: this.org_name,
        Typeofbusiness: this.Typeofbusiness,
        targeted_monthly_sale: this.targeted_monthly_sale,
        targeted_ad_cost: this.targeted_ad_cost,
        operating_country: this.operating_country,
        preferred_timezone: this.preferred_timezone,
      };

      // Make a POST request to save the form data
      this.$http
        .post(this.api_url + "/multiuser/save_org_form_details", formData)
        .then((response) => {
          // Handle the response if needed
          console.log("Response is saved", response.data);
          this.$top_level_orgid.label = response.data["top_level_orgid"];
          localStorage.setItem("top_level_orgid", response.data[0]['top_level_orgid']);

          // Close the organization form dialog
          this.showorganizationform = false;
          this.$router.push({
            name: "SignIn",
          });
        })
        .catch((error) => {
          console.error("Error saving data:", error);
        });
    },
    maskData(item) {
      // Check if the email is equal to 'support@uniqin.ai'
      const email = this.$store.state.credentials["attributes"]["email"];

      if (email === "support@uniqin.ai") {
        return "Demo";
      }

      // If the email doesn't match the condition, return the original data
      return item; // or you can replace it with a different mask if needed
    },


    trackingdashboard() {
      this.$mixpanel.track('Home', {
        info: 'User in Home Page'
      })

    },
    trackqdrawer(pageName) {
      this.$mixpanel.track(`Amazon Tools /${pageName}`, {
        info: `User entered ${pageName}`,
      });
    },
    trackQsmartselldashboard(pages) {
      this.$mixpanel.track(`Qsmartsell Dashboard /(${pages})`, {
        info: `User entered ${pages}`,
      });

    },
    trackingadoptimization(pageName) {
      this.$mixpanel.track(`Ad Optimization /${pageName}`, {
        info: `User entered ${pageName}`,
      });
    },
    priceoptimization(pagename) {
      this.$mixpanel.track(`Dashboard /(${pagename})`, {
        info: `User entered ${pagename}`,
      });

    },
    repricer() {
      this.$mixpanel.track('Sales Optimization/Repricer', {
        info: 'User Entered Repricer'
      })
    },
    trackingpurchase() {
      this.$mixpanel.track('Qsmartsell Dashboard/Purchase', {
        info: 'User Selected Purchase now operation'
      })

    },
    trackingcancel() {
      this.$mixpanel.track('Qsmartsell Dashboard/Cancel', {
        info: 'User Selected Cancel option'
      })

    },
    trackingpricetracker(pricetracker) {
      this.$mixpanel.track(`PriceTracker ${pricetracker}`, {
        info: `User Clicked ${pricetracker}`
      })


    },


    maskData(item) {
      // Check if the email is equal to 'support@uniqin.ai'
      const email = this.$store.state.credentials['attributes']['email'];

      if (email === 'support@uniqin.ai') {
        return 'Demo';
      }

      // If the email doesn't match the condition, return the original data
      return item; // or you can replace it with a different mask if needed
    },


    handleImageError() {
      // This method is called when the image fails to load (not available)
      this.logosource = this.defaultLogoSource;
    },

    maskData(item) {
      // Check if the email is equal to 'support@uniqin.ai'
      const email = this.$store.state.credentials["attributes"]["email"];

      if (email === "support@uniqin.ai") {
        return "Demo";
      }

      // If the email doesn't match the condition, return the original data
      return item; // or you can replace it with a different mask if needed
    },

    toggleSubMenu() {
      this.subMenuOpen = !this.subMenuOpen;
      this.isExpanded = false;
      this.performancereport = false;
    },
    togglePanelItems() {

      this.isExpanded = !this.isExpanded;
      this.subMenuOpen = false;
      this.performancereport = false;
    },
    settingsItems() {
      this.isUser = !this.isUser;
      this.subMenuOpen = false;
      this.isExpanded = false;
      this.performancereport = false;


    },
    togglereports() {
      this.performancereport = !this.performancereport;
      this.isExpanded = false;
      this.subMenuOpen = false;
    },
    get_orgname(details) {
      console.log('details', details)
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track(`Item clicks (${details})`, {
        To: details,
        From: this.orgNameDisplay,
        Date: new Date().toDateString(),
        Time: istTime,
        Path: `User went from ${this.orgNameDisplay} to ${details}!.`

      });
      // this.selectedorgname = details;
      // this.selectedorg = details;

      this.showMaskedData = false;
      const email = this.$store.state.credentials["attributes"]["email"];
      if (email === "support@uniqin.ai") {
        return (this.orgNameDisplay = "Demo");
      } else {
        this.orgNameDisplay = details;
      }
      console.log("Names", this.orgNameDisplay);
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
      let products = this.data_temp.filter((items) => {
        return items.profile_name == this.orgNameDisplay;
      });
      // console.log('bp1')
      this.oganisationData = products;
      this.organizationId = this.oganisationData[0]["org_id"].toString();
      this.subscriptionPlan = this.oganisationData[0]["subscription_type"];
      this.subscriptionEndDate = this.oganisationData[0][
        "subscription_end_date"
      ].slice(0, 10);
      this.$org_encryprt.label = this.oganisationData[0]["encoded_org_id"];
      this.$orgName.label = this.oganisationData[0]["profile_name"];
      this.$org_id.label = this.oganisationData[0]["org_id"];
      if (this.orgNameDisplay === 'Demo') {
        this.logosource = this.defaultLogoSource;
      }
      else {
        this.logosource =
          "https://seller-logos.s3.us-west-2.amazonaws.com/" +
          process.env.VUE_APP_ENV +
          "_logos/" +
          this.$org_id.label +
          ".jpeg";

      }
      console.log("logo src:", this.logosource);
      this.api_call();
    },
    api_call() {
      this.$cookies.keys().forEach((cookie) => this.$cookies.remove(cookie));
      if (
        this.oganisationData[0]["subscription_type"] == "SILVER" &&
        this.oganisationData[0]["valid_access"] == "all"
      ) {
        let end_point = this.$CryptoJS.AES.encrypt(
          "authenticated",
          process.env.VUE_APP_ENCRYPTION_SECRET_KEY
        ).toString();

        this.$cookies.set("login_authentication2", end_point, 0);
        this.authenticate = true;
        this.$store.dispatch("setSignedIn", true);
      } else if (
        (this.oganisationData[0]["subscription_type"] == "SILVER" &&
          this.oganisationData[0]["valid_access"] == "dashboard") ||
        (this.oganisationData[0]["subscription_type"] == "GOLD" &&
          this.oganisationData[0]["valid_access"] == "dashboard")
      ) {
        let end_point = this.$CryptoJS.AES.encrypt(
          "authenticated",
          process.env.VUE_APP_ENCRYPTION_SECRET_KEY
        ).toString();

        this.$cookies.set("login_authentication1", end_point, 0);
        this.authenticate = true;
        this.$store.dispatch("setSignedIn", true);
      } else if (
        this.oganisationData[0]["valid_access"] == "all" &&
        this.oganisationData[0]["subscription_type"] == "GOLD"
      ) {
        let end_point = this.$CryptoJS.AES.encrypt(
          "authenticated",
          process.env.VUE_APP_ENCRYPTION_SECRET_KEY
        ).toString();

        this.$cookies.set("login_authentication", end_point, 0);
        this.authenticate = true;
        this.$store.dispatch("setSignedIn", true);
      } else {
        this.$q.loading.hide();
        // this.$store.dispatch("setSignedIn", false);
        this.authenticate = false;
        console.log('homedash')
        this.$router.push({
          name: "HomeDashboard",
        });
        console.log('homedash')
      }
      this.$q.loading.hide();
      this.get_notifications();
      // this.mounted1();
    },
    get_notifications() {
      var productsURL =
        this.api_url +
        "/products/notifications/" +
        this.oganisationData[0]["org_id"];

      this.$http.get(productsURL).then((response) => {
        let result = response.data;
        let data = result.map((items) => {
          return {
            ...items,
            // input: items.compare_at_price ? items.compare_at_price : 0,
          };
        });
        for (var i = 0; i < data.length; ++i) {
          if (data[i]["is_notification_read"] !== true) {
            this.counting++;
          }
        }
        this.counter = this.counting;
        const sortedData = data
          .slice()
          .sort(function (a, b) {
            let c = new Date(a.timestamp_of_creation);
            let d = new Date(b.timestamp_of_creation);
            return d - c;
          })
          .map((items) => {
            return {
              ...items,
            };
          });
        this.notification_data = sortedData;
      });
    },
    gettingDate(date_time) {
      let dat = new Date(date_time);
      return dat.toISOString().slice(0, 10);
    },
    notifications() {
      if (this.home_dashboard_path == true) {
        this.$notificationOn.label = "123";
      } else {
        this.fixed = true;
        this.counter = 0;
        for (var i = 0; i < this.counting; ++i) {
          var postURL = this.api_url + `/products/notification_read`;
          this.$http
            .put(postURL, [this.notification_data[i]])
            .then((response) => {
              if (response.data) {
                // this.$q.notify({
                // //   message: "data Changed successfully",
                // //   color: "grey-3",
                // //   textColor: "blue",
                // });
                //console.log("Notification read");
              }
            });
          var productsURL =
            this.api_url +
            "/products/notifications/" +
            this.oganisationData[0]["org_id"];
          this.$http.get(productsURL).then((response) => {
            let result = response.data;

            let data = result.map((items) => {
              return {
                ...items,
                // input: items.compare_at_price ? items.compare_at_price : 0,
              };
            });
            //console.log(data);
            const sortedData = data
              .slice()
              .sort(function (a, b) {
                let c = new Date(a.timestamp_of_creation);
                let d = new Date(b.timestamp_of_creation);
                return d - c;
              })
              .map((items) => {
                return {
                  ...items,
                };
              });
            this.notification_data = sortedData;
            //console.log(this.notification_data);
          });
        }
        this.counting = 0;
      }
    },
    checkPathInventory() {
      if (this.showTabI === false) {
        this.showTabI = true;
      } else {
        if (window.location.pathname === "/inventoryoptimization/home") {
          this.showTabI = false;
        }
        // this.showTabI =( window.location.pathname == '/inventoryoptimization/home')
      }

      // this.showHist=false
      // this.showTab=false
      // this.recom=false
    },
    checkPathPrice() {
      //console.log(window.location.pathname);
      if (this.showHist === false) {
        this.showHist = true;
      } else {
        if (window.location.pathname === "/priceoptimization/home") {
          this.showHist = false;
        }
      }
      // this.showHist=false;
      // }else
      // {
      //   this.showHist =( window.location.pathname == '/priceoptimization/home')
      // }
    },
    checkPathPriceWatch() {
      //console.log(window.location.pathname);
      if (this.showHist) {
        this.showHist2 = false;
      } else {
        this.showHist2 = window.location.pathname == "/pricewatch/home";
      }
      this.showTab2 = window.location.pathname == "/pricewatch/resultshistory";
    },
    checkPath() {
  
      this.showTab = window.location.pathname == "/recommendations";
      this.proselectP =
        window.location.pathname == "/priceoptimization/revenue";
      this.recom = false;
      this.showHist = false;
      this.recomI = false;
    },
    showProfileDropDown() {
      this.profileDropDown = !this.profileDropDown;
    },
    getProfile() {
      this.$http
        .get(this.profile_url)
        .then((res) => {
          if (res.data.count == 1) {
            this.$store.dispatch("setProfileExists", true);
            this.$store.dispatch("setProfile", res.data.result);
          }
        })
        .catch((err) => {
          this.$store.dispatch("setProfileExists", false);
          this.$store.dispatch("setProfile", err.message);
        });
    },
    pageTrack() {
      Analytics.autoTrack("pageView", {
        // REQUIRED, turn on/off the auto tracking
        enable: true,
        // OPTIONAL, the event name, by default is 'pageView'
        eventName: "pageView",
        // OPTIONAL, the attributes of the event, you can either pass an object or a function
        // which allows you to define dynamic attributes
        attributes: {
          // attr: 'attr'
        },
        // when using function
        // attributes: () => {
        //    const attr = somewhere();
        //    return {
        //        myAttr: attr
        //    }
        // },
        type: "SPA",
        // OPTIONAL, the service provider, by default is the Amazon Pinpoint
        provider: "AWSPinpoint",
        // OPTIONAL, to get the current page url
        getUrl: () => {
          // the default function
          return window.location.origin + window.location.pathname;
        },
      });
    },
    updatePinpointEndpoint() {
      var userEmail =
        this.$store.state.credentials.signInUserSession.idToken.payload.email;
      Analytics.updateEndpoint({
        address: userEmail, // The unique identifier for the recipient. For example, an address could be a device token, email address, or mobile phone number.
        attributes: {
          // Custom attributes that your app reports to Amazon Pinpoint. You can use these attributes as selection criteria when you create a segment.
          // hobbies: ["piano", "hiking"],
        },
        // channelType: "APNS", // The channel type. Valid values: APNS, GCM
        // demographic: {
        //   appVersion: "xxxxxxx", // The version of the application associated with the endpoint.
        //   locale: "xxxxxx", // The endpoint locale in the following format: The ISO 639-1 alpha-2 code, followed by an underscore, followed by an ISO 3166-1 alpha-2 value
        //   make: "xxxxxx", // The manufacturer of the endpoint device, such as Apple or Samsung.
        //   model: "xxxxxx", // The model name or number of the endpoint device, such as iPhone.
        //   modelVersion: "xxxxxx", // The model version of the endpoint device.
        //   platform: "xxxxxx", // The platform of the endpoint device, such as iOS or Android.
        //   platformVersion: "xxxxxx", // The platform version of the endpoint device.
        //   timezone: "xxxxxx", // The timezone of the endpoint. Specified as a tz database value, such as Americas/Los_Angeles.
        // },
        // location: {
        //   city: "xxxxxx", // The city where the endpoint is located.
        //   country: "xxxxxx", // The two-letter code for the country or region of the endpoint. Specified as an ISO 3166-1 alpha-2 code, such as "US" for the United States.
        //   latitude: 0, // The latitude of the endpoint location, rounded to one decimal place.
        //   longitude: 0, // The longitude of the endpoint location, rounded to one decimal place.
        //   postalCode: "xxxxxx", // The postal code or zip code of the endpoint.
        //   region: "xxxxxx", // The region of the endpoint location. For example, in the United States, this corresponds to a state.
        // },
        metrics: {
          // Custom metrics that your app reports to Amazon Pinpoint.
        },
        /** Indicates whether a user has opted out of receiving messages with one of the following values:
         * ALL - User has opted out of all messages.
         * NONE - Users has not opted out and receives all messages.
         */
        optOut: "ALL",
        // Customized userId
        // userId: this.userEmail,
        // User attributes
        userAttributes: {
          // interests: ["football", "basketball", "AWS"],
          // ...
        },
      }).then(() => {
        //console.log("pinpoint endpint updated");
      });
    },

    async sign_out() {
      localStorage.setItem("key", null);
      localStorage.setItem("org_name", null);
      this.$store.dispatch("setCredentials", {});
      this.$store.dispatch("setSignedIn", false);
      //console.log("Signout")
      Auth.signOut({ global: false })
        .then((res) => {
          //console.log(res);
          // mixpanel.track("Log Out");
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const istTime = now.toLocaleString('en-US', options);
          this.$mixpanel.track("Log Out", {
            Action: 'The user successfully logged out from the application.',
            Time: istTime,
            Date: new Date().toDateString(),
            UserEmail: localStorage.getEmail('email'),


          })

          // remove all cookie
          this.$cookies
            .keys()
            .forEach((cookie) => this.$cookies.remove(cookie));
          this.$store.dispatch("setPathName", " ");
        })
        .catch((err) => {
          //console.log(err)
        });
    },
    subscribe() {
      window.location.reload();
    },
    filteredItems(items) {
      // Use the filter method to get items where connection_status is 'connected'
      return items.filter((item) => item.connection_status === 'connected');
    },
  },
  computed: {


    isSubscriptionExpired() {
      // Convert subscriptionEndDate to a Date object and compare with the current date
      const endDate = new Date(this.subscriptionEndDate);
      const currentDate = new Date();
      return endDate < currentDate;
    },

    loginii() {
      //console.log(window.location.pathname);
    },
    signedIn() {
      return this.$store.state.signedIn;
    },
    userFullName() {
      if (this.$store.state.credentials.signInUserSession)
        return this.$store.state.credentials.signInUserSession.idToken.payload
          .name;
      else return "";
    },
    userPhotoUrl() {
      var picture =
        this.$store.state.credentials.signInUserSession.idToken.payload.picture;
      if (typeof picture === "string") {
        try {
          // facebook returns an object
          return JSON.parse(picture).data.url;
        } catch {
          // google returns a string
          return picture;
        }
      } else {
        return "https://seller-logos.s3.us-west-2.amazonaws.com/test_logos/blank-profile-picture.webp";
      }
      // this.getProfile()
    },

    userEmail() {
      if (this.$store.state.credentials.signInUserSession)
        return this.$store.state.credentials.signInUserSession.idToken.payload
          .email;
      else return "";
    },
    profile_url() {
      return this.$store.state.API_URL[process.env.VUE_APP_ENV] + "/me";
    },
    sub() {
      return this.$store.state.credentials.signInUserSession.idToken.payload
        .sub;
    },

    home_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/home") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    settings_path() {
      //console.log("Path", window.location.pathname);


      if (this.$store.state.pathName == "/settings") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },


    price_watch_addproduct_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/pricewatch/addproduct") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_watch_analytics_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/pricewatch/analytics") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_watch_dashboard_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/pricewatch/dashboard") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_watch_results_history_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/pricewatch/resultshistory") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_watch_notification_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/pricewatch/notification") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    home_dashboard_path() {
      //console.log("Path", window.location.pathname);
      if (this.$store.state.pathName == "/homedashboard") {
        console.log("path", window.location.pathname);
        return true;
      } else return false;
    },

    price_watch_path() {
      //console.log("Path", window.location.pathname);

      let arr = this.$store.state.pathName.split("/");
      if (arr[1] == "pricewatch") {
        return true;
      } else return false;
    },

    price_optimization_path() {
      //console.log("Path", window.location.pathname);

      let arr = this.$store.state.pathName.split("/");
      if (arr[1] == "priceoptimization") {
        return true;
      } else return false;
    },

    price_optimization_select_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/select") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_revenue_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/revenue") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_resultshistory_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/resultshistory") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_revenue_recommendation_path() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName ==
        "/priceoptimization/revenue-recommendations"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    price_optimization_home() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/home") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_profit_recommendation_path() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName ==
        "/priceoptimization/profit-recommendations"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    price_optimization_profit() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName == "/priceoptimization/profit?type=profit"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    price_optimization_revenue() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName == "/priceoptimization/revenue?type=revenue"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    price_optimization_volume() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName == "/priceoptimization/volume?type=volume"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_volume_recommendation_path() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName ==
        "/priceoptimization/volume-recommendations"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_revenue_summary_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/revenue-summary") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_profit_summary_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/profit-summary") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_volume_summary_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/volume-summary") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    price_optimization_offline_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/priceoptimization/offline") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_path() {
      //console.log("Path", window.location.pathname);

      let arr = this.$store.state.pathName.split("/");
      if (arr[1] == "amazonadoptimization") {
        return true;
      } else return false;
    },
    amazon_adoptimzation_ad_summary_path() {
      //console.log("Path123", window.location.pathname);

      if (this.$store.state.pathName == "/amazonadoptimization/adsummary") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_ad_schedule_path() {
      //console.log("Path123", window.location.pathname);

      if (this.$store.state.pathName == "/amazonadoptimization/adschedule") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_keywordSearchTerm_path() {
      //console.log("Path123", window.location.pathname);

      if (
        this.$store.state.pathName == "/amazonadoptimization/keywordSearchTerm"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_Campaign_manager() {
      //console.log("Path123", window.location.pathname);

      if (
        this.$store.state.pathName == "/amazonadoptimization/campaignmanager"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_ad_performance_path() {
      //console.log("Path123", window.location.pathname);

      if (
        this.$store.state.pathName == "/amazonadoptimization/adperfomacereports"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_adoptimzation_ad_performance_keyword_path() {
      //console.log("Path123", window.location.pathname);

      if (
        this.$store.state.pathName ==
        "/amazonadoptimization/adperfomacereports/keywordanalysis"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    amazon_application_path() {
      //console.log("Path", window.location.pathname);

      let arr = this.$store.state.pathName.split("/");
      //console.log("Path12", this.$store.state.pathName.split("/"));
      if (arr[1] == "amazonrepricer") {
        return true;
      } else return false;
    },
    amazon_repricer_qsmartsell() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/amazonrepricer/qsmartsell") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_repricer_dashboard() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/amazonrepricer/dashboard") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    amazon_repricer_forecast() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/amazonrepricer/forecast") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    inventory_optimization_path() {
      //console.log("Path", window.location.pathname);

      let arr = this.$store.state.pathName.split("/");
      //console.log("Path2", window.location.pathname);
      if (arr[1] == "inventoryoptimization") {
        return true;
      } else return false;
    },

    inventory_optimization_select_mode_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/inventoryoptimization/home") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    inventory_optimization_inventory_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/inventoryoptimization/inventory") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    inventory_optimization_inventory_result_path() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName == "/inventoryoptimization/inventoryresult"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    inventory_optimization_inventory_store_result_path() {
      //console.log("Path", window.location.pathname);

      if (
        this.$store.state.pathName ==
        "/inventoryoptimization/inventoryrecommendations"
      ) {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    shops_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/shops") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },
    system_admin_path() {
      //console.log("Path", window.location.pathname);

      if (this.$store.state.pathName == "/SystemAdmin") {
        //console.log(window.location.pathname);
        return true;
      } else return false;
    },

    current_url() {
      return window.location.pathname;
    },
  },
  watch: {
    $route(to, from) {
      //console.log("session end", from["path"]);
      mixpanel.track(from["path"]);

      this.$store.dispatch("setPreviousPage", to["path"]);
      //console.log("session start", to["path"]);
      mixpanel.time_event(to["path"]);
    },
  },
  watch: {},
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400&display=swap");

.leftDrawerHeading {
  color: rgb(255, 255, 255) !important;
  display: flex;
  justify-content: center;
  font-size: 1.2rem !important;
  font-weight: 900 !important;
  font-family: "Poppins", sans-serif !important;
  height: 60px;
  text-align: center;
  background: #378cef 0% 0% no-repeat padding-box;
  border-radius: 10px 10px 0px 0px;
  padding-top: 4rem;
  align-items: center;
}

#app {
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}

/* #nav {
  padding: 30px;
} */
#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: black;
  background-color: rgb(9, 95, 194) 40%;
}

.main-menu {
  float: left;
}

.content {
  margin: 20px;
}

.app-menu {
  /* margin-top: 30px; */
  /* margin: 5px; */
  width: 150px;
  border-radius: 0%;
  border: 1px solid rgb(252, 6, 6);
  color: #eef2f7;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Poppins", sans-serif !important;
}

.header {
  overflow: hidden;
  background-color: #0a69e669;
  padding: 2px 4px;
}

.header a {
  float: left;
  color: #f5f5dc;
  text-align: left;
  padding: 12px;
  text-decoration: none;
  font-size: 15px;
  line-height: 15px;
  border-radius: 2px;
}

.header a.logo {
  font-size: 25px;
  font-weight: bold;
}

.header a:hover {
  background-color: #ddd;
  color: black;
}

.header a.active {
  background-color: dodgerblue;
  color: white;
}

.header-right {
  float: right;
}

.app-sidebar {
  height: 100%;
  width: 200px;
  background-color: #fff;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
}

.app-light-grey,
.app-hover-light-grey:hover,
.app-light-gray,
.app-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
}

.app-bar-block .app-dropdown-hover,
.app-bar-block .app-dropdown-click {
  width: 100%;
}

.app-bar-block .app-dropdown-hover .app-dropdown-content,
.app-bar-block .app-dropdown-click .app-dropdown-content {
  min-width: 100%;
}

.app-bar-block .app-dropdown-hover .app-button,
.app-bar-block .app-dropdown-click .app-button {
  width: 100%;
  text-align: left;
  padding: 8px 16px;
}

.app-bar-block .app-bar-item {
  width: 100%;
  display: block;
  padding: 8px 16px;
  text-align: left;
  border: none;
  white-space: normal;
  float: none;
  outline: 0;
}

.app-bar-block.app-center .app-bar-item {
  text-align: center;
}

.app-block {
  display: block;
  width: 100%;
}

.signout {
  color: white;
}

.drawer-uniqin {
  color: red;
  padding-left: 10px;
}

.dummy {
  color: red;
  /* visibility: hidden; */
  padding-left: 30px;
  margin-left: 20px;
}

.router-link-active {
  color: rgb(238, 20, 20);
  text-decoration: none;
}

.router-link-active {
  color: #ffffff;
  z-index: 10000;
  text-decoration: none;
}

.my-menu-link {
  color: white;
  background: #f2c037;
}

.q-header {
  margin: 10px;
  box-shadow: 0px 4px 12px #00000033 !important;
  border-radius: 10px;
  height: 60px;
}

.q-layout__shadow::after {
  box-shadow: none !important;
}

.q-drawer {
  width: 222px !important;
  transform: translateX(0px);
  margin: 10px !important;
}

.q-drawer--left {
  border-right: 0px !important;
  background-color: #f4f7fc !important;
}

.drawerItems {
  color: black !important;
}

.container_body {
  background: #f4f7fc !important;
}

.home-shop {
  margin-top: 20px;

  width: 100%;

}

.home,
.shop {
  width: 100%;

}

.drawerItems {
  border-radius: 10px;
}

.q-item__section--side {
  align-items: center !important;
  padding-right: 0px !important;
  width: auto;
  min-width: 0;
  max-width: 100%;
}

.drawerItems_active {
  color: white !important;
  background: #378cef 0% 0% no-repeat padding-box !important;
  font-weight: 400 !important;
  font-size: 0.8rem;
  letter-spacing: 0.01786em;
}

.left-icons {
  padding: 0px;
}

.q-item__section--avatar {
  color: inherit;
  min-width: 45px !important;
}

.Items_active {
  color: #378cef !important;
  font-weight: bold;
  background-color: yellow !important;

  .left-icons {
    border-left: 5px solid #378cef;
  }
}

.q-item-class {
  padding: 0px !important;
}

.drawerItems {
  font-weight: 600 !important;
  font-size: 0.8rem;
  letter-spacing: 0.01786em;
  background: 0% 0% no-repeat padding-box;
}

.Items {
  font-weight: 500 !important;
  font-size: 0.95rem;

  color: #3a4c70;
}

.sign_out {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: none;
}

.fit {
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000030;
}

.user {
  width: 100%;
  text-align: center;
}

.q-toolbar__title {
  font-size: 16px !important;
  font-weight: normal;
  letter-spacing: 0.01em;
}

.left-dashboard {
  border-radius: 10px 10px 0px 0px;
  // background-color:#EDF1F5;
}

.left-dashboard-1 {
  border-radius: 0px 0px;
  background-color: #edf1f5;
}

.sidebartext {
  font-size: 13px;
}

.sidebarnonactive {
  pointer-events: none;
  opacity: 0.6;
}

.sidebaractive {
  opacity: 1;
}

.sidebartext-semi {
  font-size: 12px;
}

@media screen and (max-width: 500px) {
  .header a {
    float: none;
    display: block;
    text-align: left;
  }

  .header-right {
    float: none;
  }
}

.highlighted {
  background-color: #efecec;
  color: white;
  /* Change this to your desired highlight style */
}

.subscription-panel {
  margin-top: 90px;
  background: unset 0% 0% no-repeat padding-box;
  padding: 10px;
  border-radius: 20px;
  opacity: 1;
  font-size: 13px;
  margin-bottom: 10px;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .subscription-panel {
    margin-top: 200px;
    /* Adjust this value as needed for smaller screens */
  }
}

/* Media query for screens with a maximum width of 480px */
@media (max-width: 480px) {
  .subscription-panel {
    margin-top: 150px;
    /* Adjust this value as needed for even smaller screens */
  }
}

.title-sub {
  text-align: left;
  letter-spacing: 0.07px;
  color: #131523;
  font-weight: 600;
  opacity: 1;
}

.sub-data {
  text-align: left;
  font: normal normal normal 12px/11px Poppins;
  letter-spacing: 0px;
  color: #7f8fa4;
  opacity: 1;
}

.purchase {
  text-align: left;
  font: normal normal bold 13px/15px Raleway;
  letter-spacing: 0px;
  color: #322a7d;
  opacity: 1;
}

.cancel {
  text-align: left;
  font: normal normal bold 13px/15px Raleway;
  letter-spacing: 0px;
  color: #fe3d3d;
  opacity: 1;
}

.arrow {
  margin-left: 5px;
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
}

.up-1 {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down-1 {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.q-avatar__content,
.q-avatar img:not(.q-icon) {
  color: black !important;
}

.organizationform {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 605px;
  min-width: 510px;
  padding: 10px;
  position: fixed;
  width: 510px;
  z-index: 2;
  top: 50%;
  left: 20%;
  transform: translate(-50%, -50%);
  margin: auto;
  overflow: hidden !important;
}

@media (max-width: 600px) {
  .organizationform {
    top: 30%;
  }
}

@media (min-width: 1024px) {
  .organizationform {
    top: 50%;
  }
}

.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  /* Adjust the z-index as needed */
  backdrop-filter: blur(10px);
  /* Adjust the blur intensity as needed */
}

@media only screen and (max-width:600px) {}
</style>